<template>
    <b-button
        variant="primary"
        @click="confirmar()"
        :disabled="desabilitarSalvar"
        ><i class="fa fa-check-circle-o"></i> Salvar</b-button
    >
</template>

<script>
import TiposMovimentosServicos from './TiposMovimentosServicos'

export default {
    props: {
        tipoMovimento: {
            type: Object,
            default: () => ({})
        },

        operacao: {
            type: String,
            default: () => 'INSERIR'
        },

        desabilitarSalvar: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmar() {
            this.$swal({
                title: 'Tipo Movimento',
                html: `Confirma a ${
                    this.operacao == 'INSERIR' ? 'inserção' : 'atualização'
                } do tipo de movimento <strong>${this.tipoMovimento.codMov}</strong>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar(result.value)
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            TiposMovimentosServicos.salvar(this.tipoMovimento).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.registroSalvoComSucesso()
                        } else {
                            this.$emit('atualizarErros', response.errors)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Operação realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterTiposMovimentosAtualizados')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
